import { ArcadeAvatar, ArcadeAvatarSize, PaddingInset } from '@cash-design-system/react'
import { getArcadeAvatarPropsFromUiAvatarProto } from '@cash-web/avatar-from-proto'
import { Icon } from '@cash-web/protos/squareup/cash/ui/Icon.pb'
import {
  FormBlockerElementAvatarElement,
  FormBlockerElementAvatarElementAvatar,
  FormBlockerElementAvatarElementAvatar_Size,
  FormBlockerElementAvatarElementBadge,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { UiAvatar, UiAvatarBadgeShape } from '@cash-web/protos/squareup/franklin/ui/ui_avatar.pb'

const FORM_BLOCKER_AVATAR_SIZE_MAP: Record<FormBlockerElementAvatarElementAvatar_Size, ArcadeAvatarSize> = {
  [FormBlockerElementAvatarElementAvatar_Size.SMALL]: 'small',
  [FormBlockerElementAvatarElementAvatar_Size.MEDIUM]: 'medium',
  [FormBlockerElementAvatarElementAvatar_Size.LARGE]: 'large',
  [FormBlockerElementAvatarElementAvatar_Size.EXTRA_LARGE]: 'large',
}

const BADGE_ICON_MAP: Record<FormBlockerElementAvatarElementBadge, Icon> = {
  [FormBlockerElementAvatarElementBadge.CHECKMARK]: {
    arcade_id: 'YVnxSd', // checkmark icon
  },
  [FormBlockerElementAvatarElementBadge.LINK]: {
    arcade_id: 'oywrej', // hyperlink icon
  },
  [FormBlockerElementAvatarElementBadge.PAYMENT_PLAN]: {
    arcade_id: 'g7giOn', // pay in 4 icon
  },
  [FormBlockerElementAvatarElementBadge.RECURRING_SINGLE_ARROW]: {
    arcade_id: '0IwHcW', // recurring automatic icon
  },
}

const formBlockerAvatarToUiAvatar = (
  avatar: FormBlockerElementAvatarElementAvatar,
  badge?: FormBlockerElementAvatarElementBadge
): UiAvatar => {
  const { background_color, monogram_text, photo_url, image, is_template_avatar, badge_image, badge_shape } = avatar

  return {
    background_color,
    monogram_text,
    ...(image || photo_url ? { image: image ?? { light_url: photo_url } } : {}),
    is_template_avatar,
    badge_image,
    badge_icon: badge ? BADGE_ICON_MAP[badge] : undefined,
    badge_shape: badge_shape ? UiAvatarBadgeShape.CIRCULAR : undefined,
  }
}

export const AvatarElement = ({ avatars, ui_avatars, badge, avatars_size }: FormBlockerElementAvatarElement) => {
  const uiAvatars = ui_avatars ?? []
  const avatarsToUiAvatars =
    avatars?.map(avatar => formBlockerAvatarToUiAvatar(avatar, avatars.length === 1 ? badge : undefined)) ?? []

  if (uiAvatars.length === 0 && avatarsToUiAvatars.length === 0) {
    return null
  }

  const avatarsToRender = uiAvatars.length > 0 ? uiAvatars : avatarsToUiAvatars

  const arcadeAvatarProps = avatarsToRender.map(uiAvatar =>
    getArcadeAvatarPropsFromUiAvatarProto({ uiAvatarProto: uiAvatar })
  )

  const size = avatars_size ? FORM_BLOCKER_AVATAR_SIZE_MAP[avatars_size] : 'medium'

  let avatarElement: React.ReactNode

  if (avatarsToRender.length === 2) {
    avatarElement = <ArcadeAvatar stackedAvatars={arcadeAvatarProps.reverse()} size={size} />
  } else {
    avatarElement = <ArcadeAvatar {...arcadeAvatarProps[0]} size={size} />
  }

  return <PaddingInset>{avatarElement}</PaddingInset>
}
